var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"k-line-area bg-1d1d29"},[_c('tv-top'),_c('div',{staticStyle:{"width":"100%","height":"460px"},attrs:{"id":"tv_chart_container"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }